import styled from "styled-components";
import { Button } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const TopbarIconButton = styled(Button)`
    && {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0;
        width: 35px;
        height: 35px;
        min-width: 0;
        border: none;

        position: relative;

        &.TopbarIconButton-selected {
            background: ${UIStyleConstants.BLUE_VERY_LIGHT_COLOR};
        }

        img {
            transform: scale(1);
            max-width: 20px;
        }
    }
`;
